import ROUTES from './routes'

export const MODE = {
  NEW: 'new',
  NOT_MODIFIED: 'not_modified',
  DELETED: 'deleted',
}

export const ERROR_STATUS = [401]

export const CustomType = {
  flag: '0',
  number: '2',
  date: '1',
  text: '3',
}

export const PosType = {
  bepoz: 'bepoz',
  swift: 'swift',
}

export const SwiftPosExcludeSideMenu = [
  '/product',
  '/listing/7',
  ROUTES.EMAIL_TEMPLATES,
  ROUTES.CONFIRMATION,
  ROUTES.POINT_RATIO_REWARDS,
  ROUTES.FEATURE_CONTROL,
  ROUTES.NOTIFICATION_SETTING,
  ROUTES.GAMES,
  ROUTES.GIFT_CERTIFICATE,
  ROUTES.CAMPAIGNS,
  ROUTES.SUBSCRIPTION,
  ROUTES.CHARITY,
  ROUTES.CHARITY_NOMINATIONS,
]
